import { render, staticRenderFns } from "./ShareChoice.vue?vue&type=template&id=42c11290&scoped=true"
import script from "./ShareChoice.vue?vue&type=script&lang=ts"
export * from "./ShareChoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c11290",
  null
  
)

export default component.exports